export enum ChartViewModesEnum {
    GALLERY,
    LIST
}
